import { render, staticRenderFns } from "./OnlineOrderMatching.vue?vue&type=template&id=22164f19&scoped=true&"
import script from "./OnlineOrderMatching.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderMatching.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOrderMatching.vue?vue&type=style&index=0&id=22164f19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22164f19",
  null
  
)

export default component.exports